import React from 'react';
import { useAiSidebarContext } from '@/creditflowresearch/application/AiSidebar/AiSidebarContext';
import {
  SIDEBAR_MAX_WIDTH,
  SIDEBAR_MIN_WIDTH,
  SIDEBAR_WIDTH_STEP,
} from '@/creditflowresearch/application/AiSidebar/constants';

import styles from './resizeHandle.module.scss';

const ResizeHandle = () => {
  const { width, startResizing, stopResizing, resizeTo, resizeBy } = useAiSidebarContext();

  const handlePointerDown = (event: React.PointerEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.currentTarget.setPointerCapture(event.pointerId);
    startResizing();
  };

  const handlePointerMove = (event: React.PointerEvent<HTMLDivElement>): void => {
    if (event.currentTarget.hasPointerCapture(event.pointerId)) {
      resizeTo(window.innerWidth - event.clientX);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      resizeBy(event.key === 'ArrowLeft' ? SIDEBAR_WIDTH_STEP : -SIDEBAR_WIDTH_STEP);
    }

    if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      resizeTo(event.key === 'Home' ? SIDEBAR_MIN_WIDTH : SIDEBAR_MAX_WIDTH);
    }
  };

  return (
    <div
      className={ styles.handle }
      role="separator"
      aria-orientation="vertical"
      aria-label="Resize Ask AI panel"
      aria-valuenow={ width }
      aria-valuemin={ SIDEBAR_MIN_WIDTH }
      aria-valuemax={ SIDEBAR_MAX_WIDTH }
      tabIndex={ 0 }
      onPointerDown={ handlePointerDown }
      onPointerMove={ handlePointerMove }
      onPointerUp={ stopResizing }
      onPointerCancel={ stopResizing }
      onKeyDown={ handleKeyDown }
      data-test="aiSidebarResizeHandle"
    />
  );
};

export default ResizeHandle;
